<template>
    <section class="chart-container" >
        <div class=" ml20 mr20" >

            <div class="white_bg yinying br10 pt50 pb50 mb20 p20 mt50" >
                <el-select  v-model="optionValue" filterable placeholder="请选择类型" class="mr45">
                    <el-option
                            v-for="item in list"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code"
                    />
                </el-select>
<!--                <div class="p10 pl15 mb20 br10 " style="background-color:#F2F6FF;"><input placeholder="请输入标题" class="pt5 pb5 font20" style="width:100%;border:0; background-color:#F2F6FF;" v-model="title"  /></div>-->
                <div class=" mb20 br10 mt20 p20" style="background-color:#F2F6FF;"><textarea class="font20 " type="textarea" :rows="13" placeholder="请输入内容"  style="width:100%;border:0; background-color:#F2F6FF;resize: none;" v-model="content" /></div>

<!--                dfd{{fileList}}{{otherLicense}}-->
<!--                <el-upload class="avatar-uploader"-->
<!--                           ref="otherLicense"-->
<!--                           action-->
<!--                           :auto-upload="false"-->
<!--                           :on-preview="handlePicPreview"-->
<!--                           :on-remove="handleRemove"-->
<!--                           :file-list="fileList"-->
<!--                           :on-change="otherSectionFile"-->
<!--                           list-type="picture-card"-->
<!--                           multiple>-->
<!--                    <i class="el-icon-plus avatar-uploader-icon"></i>-->
<!--                </el-upload>-->
<!--                <el-dialog :visible.sync="dialogVisible"  append-to-body="true">-->
<!--                    <img width="100%" :src="dialogImageUrl" class="avatar">-->
<!--                </el-dialog>-->


                <div class="row flex-between mt25"><div></div><el-button class="set-other-btn font24" style="width:143px;" @click.native="feedback">提交</el-button></div>
            </div>

        </div>
    </section>
</template>

<script>
    import axios from "axios";
    export default {
        data() {
            return {
            content:'',
            list:[],
            optionValue: '',
            fileList: {},
            dialogVisible: false,
            dialogImageUrl: ''
            }
        },

        methods: {
handlePicPreview(file){
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
handleRemove(file, fileList) {
        this.fileList.map((item,index)=>{
          if(item.uid==file.uid){
            this.fileList.splice(index,1)
          }
        })
      },

otherSectionFile(file){
        const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
          const isJPG = typeArr.indexOf(file.raw.type) !== -1;
          const isLt3M = file.size / 1024 / 1024 < 3;
          if (!isJPG) {
            this.$message.error('只能是图片!');
            this.$refs.upload.clearFiles();
            this.otherFiles = null;
            return;
          }
          if (!isLt3M) {
            this.$message.error('上传图片大小不能超过 3MB!');
            this.$refs.upload.clearFiles();
            this.otherFiles = null;
            return;
          }
          this.otherFiles = file.raw;
          // FormData 对象
          var formData = new FormData();
          // 文件对象
          formData.append('file', this.otherFiles);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          methods: 'post'
        }
        this.axios.post("/api/upload/getObjectId",formData,config).then(res=>{
          this.fileList.push(file)
          if(res.data.flag == 'S'){
              this.otherPhotoObj = res.data.data.objectId
              this.otherPhoto = res.data.data.url
              this.otherLicense.push({
                certificationName: this.form.certificationName,
                certificationObj: this.otherPhotoObj,
                certificationUrl: this.otherPhoto
              })
          }else{
            this.$message.error(res.data.message)
          }
        })
      },



                            getList(){
                                 let self=this
                                 self.$axios.get(self.baseApiUrl2+'addons/shopro/feedback/type').then(function (res) {
                                    if(res.data.code==1){
                                        self.list=res.data.data
                                    }
                                 })
                            },
feedback(){
let self=this
if(this.optionValue==''){
    self.$message('您还没选择类型');
return;
}
    this.$confirm('是否确认提交？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
    }).then(() => {
                let params={type:this.optionValue,content:self.content,images:self.fileList}
                     self.$axios.post(self.baseApiUrl2+'addons/shopro/feedback/add',params).then(function (res) {
                    if(res.data.code==1){
                        self.$message({type: 'success',message: '提交成功!'});
                        self.content=''
                    }
                 })

     }).catch(() => {
    });
}

        },

        mounted: function () {
        this.getList()
        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// fankui.vue?1aa7c172